import { get } from '@/services/http';
import { ChurnMerchant, MerchantListResponse, MerchantListParams } from '@/types/churn';

export class ChurnMerchantListModel {
    public merchants: ChurnMerchant[] = [];
    public total: number = 0;
    public limit: number = 50;
    public offset: number = 0;

    public async fetch(params: MerchantListParams): Promise<void> {
        const query: any = {
            limit: params.limit,
            offset: params.offset,
            sort_by: params.sort_by,
            sort_order: params.sort_order,
        };
        if (params.tier) { query.tier = params.tier; }
        if (params.date) { query.date = params.date; }
        if (params.billing_package_id) { query.billing_package_id = params.billing_package_id; }

        const res: any = await get('/churn/merchants', query);
        this.mapData(res.data);
    }

    public mapData(data: MerchantListResponse): void {
        this.merchants = data.merchants;
        this.total = data.total;
        this.limit = data.limit;
        this.offset = data.offset;
    }
}
